// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outline-button-base-loHBm {
  border: 1px solid var(--accent-color);
}

.outline-button-disabled-ga0DS {
  border-color: var(--border-color);
}

.outline-button-disabled-ga0DS:hover {
  background-color: transparent;
}

.outline-button-disabled-ga0DS.outline-button-base-loHBm:hover .outline-button-text-IuIRR {
  color: lightgray;
}

.outline-button-disabled-ga0DS.outline-button-base-loHBm:hover .outline-button-icon-Mxr1B {
  color: lightgray;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/outline-button/outline-button.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".base {\n  border: 1px solid var(--accent-color);\n}\n\n.disabled {\n  border-color: var(--border-color);\n}\n\n.disabled:hover {\n  background-color: transparent;\n}\n\n.disabled.base:hover .text {\n  color: lightgray;\n}\n\n.disabled.base:hover .icon {\n  color: lightgray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `outline-button-base-loHBm`,
	"disabled": `outline-button-disabled-ga0DS`,
	"text": `outline-button-text-IuIRR`,
	"icon": `outline-button-icon-Mxr1B`
};
export default ___CSS_LOADER_EXPORT___;
